export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID, 
    authority: process.env.REACT_APP_AUTHORITY, 
    redirectUri: process.env.REACT_APP_REDIRECT_URI, 
  },
  cache: {
    cacheLocation: "localStorage", 
    storeAuthStateInCookie: false, 
  }
};

export const loginRequest = {
  scopes: ["User.Read"]
};

// 🔥 DEV MODE CONFIG
export const devModeConfig = {
  enabled: process.env.NODE_ENV === 'development' && 
           process.env.REACT_APP_DEV_MODE === 'true',
  
  token: process.env.NODE_ENV === 'development' ? (process.env.REACT_APP_DEV_TOKEN || '') : '',
  
  mockUser: process.env.NODE_ENV === 'development' ? {
    supplierId: '00000000-0000-0000-0000-000000000001',
    email: 'dev@test.com',
    supplierName: 'Dev Test Supplier',
    role: 'SuperAdmin', // ✅ Supplier → SuperAdmin
    username: 'devuser'
  } : null
};

// 🔥 Dev mode aktif mi kontrol et
export const isDevMode = () => {
  // ✅ Production build'de ASLA true dönmez
  if (process.env.NODE_ENV === 'production') {
    return false;
  }
  
  const enabled = devModeConfig.enabled;
  
  if (enabled) {
    console.warn('⚠️ DEV MODE ACTIVE - Authentication bypassed!');
  }
  
  return enabled;
};

// 🔥 Dev token al
export const getDevToken = () => {
  if (!isDevMode()) return null;
  return devModeConfig.token;
};

// 🔥 Mock user al
export const getMockUser = () => {
  if (!isDevMode()) return null;
  return devModeConfig.mockUser;
};

// ✅ API URL'i merkezi olarak yönet
export const getApiUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  
  if (!apiUrl) {
    throw new Error('❌ REACT_APP_API_URL is not defined in environment variables');
  }
  
  return apiUrl;
};

// ✅ Validation helper
export const validateEnvironment = () => {
  const required = [
    'REACT_APP_API_URL',
    'REACT_APP_CLIENT_ID',
    'REACT_APP_AUTHORITY',
    'REACT_APP_REDIRECT_URI'
  ];

  const missing = required.filter(key => !process.env[key]);

  if (missing.length > 0) {
    console.error('❌ Missing environment variables:', missing);
    throw new Error(`Missing required environment variables: ${missing.join(', ')}`);
  }

  console.log('✅ Environment variables validated');
};

// ✅ Production'da console.log'ları kapat
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.info = () => {};
  // console.error bırakılabilir
}
